import { useEffect, useState } from 'react'

import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { InvoicePayload } from '../types/invoicePayload'
import { getModifiedRecurringInvoicePayload } from '../utils/invoicePayload/getModifiedRecurringInvoicePayload'
import { isDocumentTypeRecurringInvoice } from '../utils/isDocumentTypeRecurringInvoice'
import { useGetInvoicePreviewData } from './useGetInvoicePreviewData'

interface UseInvoicePreviewProps {
  invoiceDraftPayload?: InvoicePayload
  documentType: InvoiceDocumentType
}

export const useInvoicePreview = ({ invoiceDraftPayload, documentType }: UseInvoicePreviewProps) => {
  const [htmlFiles, setHtmlFiles] = useState<string[] | undefined>(undefined)

  const { getInvoicePreviewData, isLoading } = useGetInvoicePreviewData({
    onSuccess: ({ data }) => {
      setHtmlFiles(data)
    },
  })

  useEffect(() => {
    if (invoiceDraftPayload) {
      const isRecurring = isDocumentTypeRecurringInvoice(documentType)
      getInvoicePreviewData({
        documentType: isRecurring ? InvoiceDocumentType.Invoice : documentType,
        payload: isRecurring ? getModifiedRecurringInvoicePayload(invoiceDraftPayload) : invoiceDraftPayload,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentType, invoiceDraftPayload])

  return {
    htmlFiles,
    isLoading,
  }
}
